export default {
  返回上一页: "返回上一頁",
  密码规则说明: "請輸入新的帳號密碼，密碼須滿足8-12位元，包含數字和字母。",
  新密码: "新密碼",
  密码必填提示: "8-12位元，包含數字和字母",
  密码格式提示: "密碼需8-12位，且包含字母和數字",
  确认密码: "確認密碼",
  确认密码必填提示: "請再次輸入密碼",
  密码不一致提示: "兩次輸入的密碼不一致",
  完成: "完成",
  帐号验证: "帳號驗證",
  重置密码: "重置密碼",
  安全通知已发送: "安全通知已發送至：",
  登录邮箱提示: "您的登錄郵箱：",
  立即登录: "立即登錄",
  邮箱验证说明: "請輸入您的登錄郵箱號，我們將發送安全驗證碼到您的郵箱。",
  无法访问邮箱說明: "如果您無法訪問註冊郵箱，請聯繫客服尋求人工幫助。",
  联系客服: "聯繫客服",
  员工工号: "員工工號",
  请输入工号: "請輸入員工工號！",
};
